import ViewFactory from "../../../helpers/viewfactory";
import { getValueAtPath } from "../../../../../utils";
import SuccessView from "../../../common/success";

export default function view() {
  const $this = this;
  const { $inputs, $timer } = this;

  $this.pollConfig = {
      onBegin() { $timer.start(); },
      onCancel() { $this.pollConfig.onComplete() },
      onSuccessful() { SuccessView && SuccessView.activate.call($this) },
      onComplete() {
          $timer.clear();
      }
  }

  return (view = ViewFactory({
    NAME: 'MOMO_ZAMBIA_CONFIRM_VIEW',
    mutables: {
      timerCurrent: 'CURRENT_TIME',
    },
    constants: {
      get phone() { return getValueAtPath($inputs, '[phone].value') },
      get selectedNetwork() { return getValueAtPath($inputs, '[network].value') }
    }
  }).call(this));
}
